import { Component, Input } from '@angular/core';
import { ITableCellItem } from 'app/main/shared/shared/table/table-cell';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';
import { PlaybooksListeningFacadeService } from '../../../store/playbooks-listening.facade.service';
import { TranslocoModule } from '@jsverse/transloco';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { CoreCommonModule } from '@core/common.module';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { IPlaybooksItemDTO } from '../../../dto/playbooks-listening.dto';

@Component({
  selector: 'app-playbook-listing-action-column',
  standalone: true,
   imports: [
     CommonModule,
     SharedModule,
     CoreCommonModule,
     TranslocoModule,
     NgbModule
   ],
  templateUrl: './playbook-listing-action-column.component.html',
  styleUrl: './playbook-listing-action-column.component.scss'
})
export class PlaybookListingActionColumnComponent implements ITableCellItem {
    @Input() columnOptions: ITableColumn;
    @Input() dataItem: IPlaybooksItemDTO;

    
    constructor(
      private _playBookListingFacade: PlaybooksListeningFacadeService,
    ) {}


    deletePlayBook() {
      this._playBookListingFacade.confirmAndDeletePlaybook(this.dataItem.id);
    }
}
